import script from "./DoctorPayoutList.vue?vue&type=script&lang=ts&setup=true"
export * from "./DoctorPayoutList.vue?vue&type=script&lang=ts&setup=true"

import "./DoctorPayoutList.vue?vue&type=style&index=0&id=f2252b70&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2252b70"]])

export default __exports__